module.exports = __webpack_public_path__ + "static/img/warning-toast.dd81d224.svg";